import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const ArrowIcon = ({
  width = "18",
  height = "18",
  color = "#1F865B",
  rotate = "0",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} rotate={rotate} style={style}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 13.5L13.5 4.5M13.5 4.5H7.5M13.5 4.5V10.5"
          stroke={color}
          strokeWidth="1.5"
        />
      </svg>
    </IconWrapper>
  );
};
